import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [shop, setShop] = useState(undefined);
  const [config, setConfig] = useState(null);

  const loadShop = useCallback(async () => {
    try {
      const { data } = await api.get("/shop");
      setShop(data.shop);
      return data.shop;
    } catch {
      setShop(null);
      return null;
    }
  }, []);

  const loadConfig = useCallback(() => api.get("/config").then((r) => setConfig(r.data)).catch(() => {}), []);

  useEffect(() => {
    loadConfig();
    api.get("/auth/me")
      .then(async (r) => {
        setUser(r.data);
        await loadShop();
      })
      .catch(() => {
        setUser(false);
        setShop(null);
      });
  }, [loadShop, loadConfig]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    await loadShop();
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data);
    setShop(null);
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
    setShop(null);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, shop, config, loadShop, loadConfig, login, register, logout }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
